import { render } from "./blockSelect.vue?vue&type=template&id=be1ee34a&scoped=true"
import script from "./blockSelect.vue?vue&type=script&lang=js"
export * from "./blockSelect.vue?vue&type=script&lang=js"

import "./blockSelect.vue?vue&type=style&index=0&id=be1ee34a&scoped=true&lang=css"

import exportComponent from "E:\\Work\\GPTWeb\\licCode\\lic\\webviewer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be1ee34a"]])

export default __exports__